import { render, staticRenderFns } from "./InfoListLabel.vue?vue&type=template&id=69eea3fa"
import script from "./InfoListLabel.vue?vue&type=script&lang=js"
export * from "./InfoListLabel.vue?vue&type=script&lang=js"
import style0 from "./InfoListLabel.vue?vue&type=style&index=0&id=69eea3fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports